import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import get from "lodash/get"
import { urls } from "utils-lib/builds"
import {
  GET_GUEST_BULK_WASTE_CLASSIFICATION_PENDING,
  GET_GUEST_BULK_WASTE_CLASSIFICATION_FAILED,
  GET_GUEST_BULK_WASTE_CLASSIFICATION_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: GET_GUEST_BULK_WASTE_CLASSIFICATION_PENDING,
})

export const failedAC = () => ({
  type: GET_GUEST_BULK_WASTE_CLASSIFICATION_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_GUEST_BULK_WASTE_CLASSIFICATION_FULFILLED,
  payload: data,
})

/**
 * Fetches bulk waste classification data for a given customer.
 * @param {string} customerId - The ID of the customer.
 * @returns {Function} A thunk action that dispatches the appropriate actions based on the API response.
 */
export const getGuestBulkWasteClassification =
  ({ input }) =>
  (dispatch, getState) => {
    dispatch(pendingAC())

    const api = `BULK_WASTE_CLASSIFICATION_GUEST`
    const apiKey = get(urls, `apiKey.GUEST[${api}]`, ``)

    const template = URITemplate(urls.url[api])

    const state = getState()
    const token = get(
      state,
      `customerSelections.cityBilledEligibility.token`,
      ``,
    )

    const url = template.expand({
      customerId: get(
        state,
        `customerSelections.cityBilledEligibility.customerId`,
        ``,
      ),
    })

    const config = {
      headers: {
        apiKey,
        token,
      },
    }

    const data = {
      text: input || "",
      eligibilityId: get(
        state,
        `customerSelections.cityBilledEligibility.eligibilityId`,
        ``,
      ),
    }
    return axios
      .post(url, data, config)
      .then((response) => {
        dispatch(fulfilledAC(response.data))
        return response.data
      })
      .catch(() => {
        dispatch(failedAC())
        return null
      })
  }
